export const generatePatchscriptFromString = (str: string) =>
  str.split('\n').map(text => ({
    align: 'center',
    pieces: [{ text: text.trim() }],
    type: 'text',
  }));
